module.exports = __webpack_public_path__ + "static/img/code1.99678d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code1.png
// module id = RCuU
// module chunks = 16